import { AlertCircle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { Empty, EmptyDescription, EmptyHeader, EmptyTitle } from "@/components/ui/empty";
import { Skeleton } from "@/components/ui/skeleton";

export function Failure({ message, retry }: { message: string; retry?: () => void }) {
  const readable = /Failed to fetch|NetworkError|Load failed/i.test(message) ? "Не удалось связаться с сервером. Проверьте соединение и повторите." : message;
  return <Alert><AlertCircle /><AlertTitle>Не удалось обновить данные</AlertTitle><AlertDescription>{readable} {retry ? <Button variant="link" onClick={retry}>Повторить</Button> : null}</AlertDescription></Alert>;
}
export function Nothing({ title, description, action }: { title: string; description: string; action?: React.ReactNode }) {
  return <Empty><EmptyHeader><EmptyTitle>{title}</EmptyTitle><EmptyDescription>{description}</EmptyDescription></EmptyHeader>{action}</Empty>;
}
export function OverviewLoading() {
  return <div role="status" aria-label="Загрузка обзора" className="grid gap-5"><Skeleton className="h-32 w-full" /><div className="grid gap-5 md:grid-cols-2"><Skeleton className="h-64" /><Skeleton className="h-64" /></div></div>;
}
